<template>
  <div class="kanban-crm d-flex flex-column h-100">
    <!-- Filtros -->
    <div class="d-flex flex-wrap align-items-center mb-2 px-2">
      <b-form-group
        label="Vendedor"
        label-cols="auto"
        class="mr-3 mb-1"
      >
        <b-form-select
          v-model="filtro.vendedor"
          :options="vendedoresOptions"
          size="sm"
        />
      </b-form-group>

      <b-form-group
        label="Origem"
        label-cols="auto"
        class="mr-3 mb-1"
      >
        <b-form-select
          v-model="filtro.origem"
          :options="origensOptions"
          size="sm"
        />
      </b-form-group>

      <b-badge
        variant="primary"
        class="ml-auto"
      >
        Total: {{ leadsFiltrados.length }}
      </b-badge>
    </div>

    <!-- Card Container -->
    <b-card class="shadow-sm rounded-lg border-0">
      <!-- Ações do topo -->
      <div class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2">
        <h5 class="mb-0">
          Leads
        </h5>
        <b-button
          variant="primary"
          size="sm"
          @click="abrirModalNovoLead"
        >
          + Novo Lead
        </b-button>
      </div>

      <!-- Kanban -->
      <div class="kanban-board d-flex overflow-auto px-2 pb-3">
        <div
          v-for="etapa in etapas"
          :key="etapa.id"
          class="kanban-column px-2 mr-3"
          style="min-width: 300px"
        >
          <h6 class="text-center text-muted font-weight-bold mb-2">
            {{ etapa.nome }}
          </h6>

          <draggable
            :list="leadsPorEtapa(etapa.id)"
            group="leads"
            :clone="cloneLead"
            class="kanban-cards py-2 px-1"
            @end="onDragEnd($event, etapa.id)"
          >
            <transition-group
              name="list"
              tag="div"
            >
              <div
                v-for="lead in leadsPorEtapa(etapa.id)"
                :key="lead.id"
                class="kanban-card card-clean p-3 mb-3 shadow-sm"
                :data-id="lead.id"
                @click="abrirModal(lead)"
              >
                <!-- Origem -->
                <div class="d-flex justify-content-between align-items-start mb-1">
                  <span class="text-muted small font-weight-bold">● {{ lead.origem }}</span>
                  <b-icon icon="three-dots-vertical" />
                </div>

                <!-- Nome do cliente -->
                <div class="font-weight-bold mb-1">
                  {{ lead.nome }}
                </div>

                <!-- Descrição (simulada) -->
                <div class="small text-muted">
                  Interessado em produtos com ticket médio de R$ {{ lead.total }}.
                </div>

                <!-- Barra de progresso -->
                <div class="my-2">
                  <div
                    class="progress"
                    style="height: 6px; background-color: #eee;"
                  >
                    <div
                      class="progress-bar"
                      role="progressbar"
                      :style="{ width: (lead.tags.length * 33) + '%', backgroundColor: '#3c9' }"
                    />
                  </div>
                </div>

                <!-- Rodapé: data e avatar -->
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <b-icon
                      icon="calendar"
                      class="mr-1"
                    />
                    <span class="small">06 Out 2024</span>
                  </div>
                  <b-avatar
                    size="28"
                    variant="light"
                  >
                    {{ lead.vendedor.charAt(0) }}
                  </b-avatar>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
    </b-card>

    <!-- Modal de Detalhes -->
    <b-modal
      v-model="modalVisivel"
      title="Detalhes do Lead"
      hide-footer
    >
      <p><strong>Nome:</strong> {{ leadSelecionado.nome }}</p>
      <p><strong>Telefone:</strong> {{ leadSelecionado.telefone }}</p>
      <p><strong>Origem:</strong> {{ leadSelecionado.origem }}</p>
      <p><strong>Vendedor:</strong> {{ leadSelecionado.vendedor }}</p>
      <p><strong>Tags:</strong>
        <b-badge
          v-for="tag in leadSelecionado.tags"
          :key="tag"
          variant="secondary"
          class="mr-1"
        >
          {{ tag }}
        </b-badge>
      </p>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { BAvatar, BIcon } from 'bootstrap-vue'

export default {
  name: 'KanbanCRM',
  components: { draggable, BAvatar, BIcon },
  data() {
    return {
      etapas: [
        { id: 'novo', nome: 'Novo Lead' },
        { id: 'contato', nome: 'Em Contato' },
        { id: 'proposta', nome: 'Proposta Enviada' },
        { id: 'pagamento', nome: 'Aguardando Pagamento' },
        { id: 'fechado', nome: 'Fechado' },
      ],
      leads: [
        {
          id: '1',
          nome: 'João da Silva',
          telefone: '5511999999999',
          etapa: 'contato',
          tags: ['urgente'],
          origem: 'Instagram',
          vendedor: 'Rodrigo',
          total: 500,
          interesse: 'alto',
        },
        {
          id: '2',
          nome: 'Maria Oliveira',
          telefone: '5511988888888',
          etapa: 'proposta',
          tags: ['novo lead'],
          origem: 'Google Ads',
          vendedor: 'Amanda',
          total: 100,
          interesse: 'baixo',
        },
        {
          id: '3',
          nome: 'Carlos Pereira',
          telefone: '5511977777777',
          etapa: 'novo',
          tags: [],
          origem: 'Orgânico',
          vendedor: 'Rodrigo',
          total: 300,
          interesse: 'médio',
        },
      ],
      modalVisivel: false,
      leadSelecionado: {},
      filtro: {
        vendedor: '',
        origem: '',
      },
      hoveredEtapa: null,
      etapaFixada: {},
    }
  },
  computed: {
    vendedoresOptions() {
      const unique = [...new Set(this.leads.map(l => l.vendedor))]
      return [''].concat(unique)
    },
    origensOptions() {
      const unique = [...new Set(this.leads.map(l => l.origem))]
      return [''].concat(unique)
    },
    leadsFiltrados() {
      return this.leads.filter(l => {
        const f = this.filtro
        return (!f.vendedor || l.vendedor === f.vendedor)
               && (!f.origem || l.origem === f.origem)
      })
    },
  },
  methods: {
    leadsPorEtapa(etapaId) {
      return this.leadsFiltrados.filter(lead => lead.etapa === etapaId)
    },
    cloneLead(lead) {
      return { ...lead }
    },
    onDragEnd(evt, novaEtapaId) {
      const movedId = evt.item?.dataset?.id
      if (!movedId) return
      const lead = this.leads.find(l => l.id === movedId)
      if (lead) lead.etapa = novaEtapaId
    },
    abrirModal(lead) {
      this.leadSelecionado = { ...lead }
      this.modalVisivel = true
    },
    getBarColor(etapaId) {
      const leadsEtapa = this.leadsPorEtapa(etapaId)
      if (!leadsEtapa.length) return 'bg-light'
      if (leadsEtapa[0].total >= 400 || leadsEtapa[0].interesse === 'alto') return 'bg-prioridade-alta'
      if (leadsEtapa[0].total >= 200 || leadsEtapa[0].interesse === 'médio') return 'bg-prioridade-media'
      return 'bg-prioridade-baixa'
    },
  },
}
</script>

<style scoped>
.kanban-crm {
  background-color: #f8f9fa;
  height: 100%;
}
.kanban-board {
  display: flex;
}
.kanban-column {
  max-height: 100%;
  background-color: transparent !important;
}
.card-clean {
  background: #fff;
  border-radius: 1rem;
  border: 1px solid #eee;
  font-size: 0.9rem;
  transition: box-shadow 0.2s ease;
}
.card-clean:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
}
</style>
